export const TERMS_OF_SERVICE = "https://www.getclaimable.com/terms-of-service";

export const PRIVACY_POLICY = "https://www.getclaimable.com/privacy-policy";
